var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradableIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 1.984h-4.64a1.16 1.16 0 00-1.16 1.16v9.281a1.16 1.16 0 001.16 1.16h6.96a1.16 1.16 0 001.16-1.16v-6.96l-3.48-3.48z",
    stroke: "#3A3A3A",
    strokeWidth: 0.79,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43 5.697h2.35M4.43 7.09h2.785M4.43 8.481H6.52M8.375 1.984v3.48h3.48",
    stroke: "#3A3A3A",
    strokeWidth: 0.696,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gradable_ic_svg__clip0_1169_1018)",
    stroke: "#3A3A3A",
    strokeWidth: 0.696,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.303 10.57a1.624 1.624 0 100-3.249 1.624 1.624 0 000 3.248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.424 10.312l-.28 2.114 1.16-.696 1.16.696-.281-2.116"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gradable_ic_svg__clip0_1169_1018"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7.215 6.393)",
    d: "M0 0h4.176v6.961H0z"
  })))));
}
export default SvgGradableIc;